import { render, staticRenderFns } from "./BMs.vue?vue&type=template&id=21f17fa0"
import script from "./BMs.vue?vue&type=script&lang=js"
export * from "./BMs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports